/**
 * Colors from the Presentation Builder V2 design mock (docs/design/presentation-builder-v2,
 * epic #22197) that aren't part of the app-wide theme palette. Shared across the inspector
 * chrome and OptionsPopup controls so the redesign stays visually consistent as more of it
 * lands.
 */
export const BUILDER_V2_INK = '#1D2433'
export const BUILDER_V2_MUTED_TEXT = '#5B6675'
export const BUILDER_V2_HOVER_BACKGROUND = '#EEF1F5'
export const BUILDER_V2_SELECTED_BACKGROUND = '#DCE6F5'
export const BUILDER_V2_BORDER = '#DDE0E6'
/** Lighter secondary-label grey — panel-header subtitles, empty-state icon, etc. Distinct from the darker BUILDER_V2_MUTED_TEXT used for body copy. */
export const BUILDER_V2_MUTED_LABEL = '#9AA4B2'
/** Lightest muted-icon grey — sub-panel close buttons (inspector, variants flyout) and row chevrons. */
export const BUILDER_V2_ICON_MUTED = '#B4BCC8'
/** Selected/active row background+text in a category or catalog list (Add panel's Sections accordion, …). Distinct from BUILDER_V2_SELECTED_BACKGROUND, which is a different control's selected state. */
export const BUILDER_V2_ROW_SELECTED_BACKGROUND = '#EAF1FE'
export const BUILDER_V2_ROW_SELECTED_TEXT = '#0F4FB0'
/** Small helper/description copy under a panel title (e.g. the Add panel's "Page names will show..." blurb). Distinct from BUILDER_V2_MUTED_LABEL and BUILDER_V2_MUTED_TEXT — the mock uses a third, in-between grey here. */
export const BUILDER_V2_HELPER_TEXT = '#8A94A2'
/** Hover text/icon color for the chrome's transparent icon buttons (top bar undo/redo, panel close buttons). */
export const BUILDER_V2_CHROME_HOVER_TEXT = '#46505F'
